import React from 'react';
import cn from 'classnames';
import styles from './BadgeIcon.module.scss';
const Wrapper = ({ children, onClick, className, ariaLabel }) => {
    if (typeof onClick === 'function') {
        return (React.createElement("button", { type: "button", className: cn(styles.button, className), onClick: onClick, "aria-live": "polite", "aria-label": ariaLabel }, children));
    }
    return React.createElement("div", { className: cn(className) }, children);
};
const BadgeIcon = ({ icon, content, hasBadge, className, onClick, ariaLabel }) => {
    if (!icon)
        return null;
    return (React.createElement(Wrapper, { ariaLabel: ariaLabel, className: cn(styles.container, className), onClick: onClick },
        hasBadge && (React.createElement("div", { className: cn(styles.badge, content && styles.largeBadge), "aria-hidden": "true", role: "presentation" }, content)),
        icon));
};
export default BadgeIcon;
//# sourceMappingURL=BadgeIcon.js.map